angular.module('core')
    .directive('hideMissingImage', function () {
        return {
            restrict: 'A',
            link: function (scope, element) {
                const hideImage = () => element.addClass('ng-hide');
                element.on('error', hideImage);
                scope.$on('$destroy', () => element.off('error', hideImage));
            }
        };
    })
    .component('companyLogo', {
        template: '<img ng-src="/crm/logo" ng-if="$ctrl.hasSystemLogo" hide-missing-image alt=""/>',
        controller: function (SYSTEM_SETTINGS, PublicSettingsService) {
            this.hasSystemLogo = false;

            this.$onInit = () => {
                if (!SYSTEM_SETTINGS.LOGIN_SHOWLOGO) {
                    return;
                }

                return PublicSettingsService.get()
                    .then(settings => this.hasSystemLogo = settings.hasSystemLogo === true);
            };
        }
    });
